import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';
import { getTrendStatus } from '@alfa-bank/site-invest-common/helpers/utils/get-trend-status';
import { TREND_STATUS } from '@alfa-bank/site-invest-common/constants/other';

import { getMathAbs, isNumber } from '../../helpers';

import styles from './styles.css';

interface IProfitabilityRendererProps {
    className?: string;
    fallbackValue?: string;
    profitabilitySymbol?: string;
    value?: number | null;
}

export const DATA_TEST_ID = 'profitability-renderer';

/** Обрабатывает относительные значения, типа profitabilityPercent */
export const ProfitabilityRenderer: FC<IProfitabilityRendererProps> = ({
    className,
    fallbackValue = '',
    profitabilitySymbol = '%',
    value,
}) => {
    const result = isNumber(value)
        ? `${separateThousands(getMathAbs(value))}${profitabilitySymbol}`
        : fallbackValue;

    const trend = getTrendStatus(value);

    return (
        <span
            className={cn(
                styles.text,
                {
                    [styles.positive]: trend === TREND_STATUS.positive,
                    [styles.negative]: trend === TREND_STATUS.negative,
                    [styles.neutral]: trend === TREND_STATUS.neutral,
                },
                className
            )}
            data-test-id={DATA_TEST_ID}
        >
            {result}
        </span>
    );
};
